import { RECEIVE_SHIPPING_ADVISORY_DATA } from "../actions/shippingAdvisoryActions";

const initialState = {};

export default function shippingAdvisoryReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_SHIPPING_ADVISORY_DATA:
      return {
        ...state,
        advisories: [...action.payload]
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/shippingAdvisoryReducer.js